// actions
export const GENERATE_DELIVERY_QUOTE = 'GENERATE_DELIVERY_QUOTE'
